import { useQuery } from '@tanstack/react-query';

import UserService from '@/services/UserService';

export const GET_USER_BY_ID_QUERY_KEY = (id: number) => ['user', id];

export function useGetUserById(id: number) {
  const { data, isFetching } = useQuery({
    queryKey: GET_USER_BY_ID_QUERY_KEY(id),
    queryFn: () => UserService.getUserById(id),
  });

  return {
    user: data,
    isLoading: isFetching,
  };
}
